var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightning01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lightning-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Solid",
    d: "M9.32842 1.9159C9.36513 1.62223 9.20384 1.33952 8.93236 1.22167C8.66089 1.10383 8.34422 1.17906 8.15475 1.40642L2.20178 8.54999C2.0989 8.67339 1.9947 8.79839 1.91883 8.90823C1.84708 9.01211 1.71608 9.21636 1.71203 9.4848C1.70739 9.79211 1.84433 10.0845 2.08339 10.2777C2.2922 10.4464 2.53297 10.4765 2.65871 10.4879C2.79166 10.4999 2.95438 10.4999 3.11504 10.4999L7.24505 10.4999L6.67205 15.0839C6.63534 15.3775 6.79663 15.6602 7.06811 15.7781C7.33958 15.8959 7.65625 15.8207 7.84571 15.5933L13.7987 8.44977C13.9016 8.32636 14.0058 8.20136 14.0816 8.09152C14.1534 7.98764 14.2844 7.78339 14.2884 7.51495C14.2931 7.20764 14.1561 6.91527 13.9171 6.72209C13.7083 6.55335 13.4675 6.52323 13.3418 6.51185C13.2088 6.49981 13.0461 6.49984 12.8854 6.49987L8.75542 6.49988L9.32842 1.9159Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning01);
export default __webpack_public_path__ + "static/media/lightning-01.07ac8771b2972a0d630490bf33a4b648.svg";
export { ForwardRef as ReactComponent };